import { ArrowDownIcon, Avatar, Box, ClockIcon, darkColors, Highlight, HStack, Icon, lightColors, Text, useColorMode, useColorModeValue as mode } from '@chaine/keychaine';
import React, { useEffect, useState } from 'react';
import { Map as ReactMapGl, MapProvider } from 'react-map-gl';
import { StyledBox } from '../styled-box';
import { currentLocationArrivedOrigin, stops } from './_data';
import { GeofenceBoundary } from './layers/geofence';
import { CurrentLocationMarker } from './marker';
import { StopsMarkers } from './marker/stop-markers';
const mapToken = String(process.env.VITE_MAPBOX_ACCESS_TOKEN);
const defaultViewState = {
    bearing: 0,
    latitude: 39.828175,
    longitude: -98.5795,
    padding: {
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    },
    pitch: 0,
    zoom: 3
};
export const MapMessageIcon = (props) => {
    const { icon = ClockIcon, iconColor = mode('red.500', 'red.400'), position = 'bottom-right', message = ' ETA 2:47 PM', mx, mt } = props;
    let positionProps = {
        mx: mx || { base: 4, md: '-12' },
        mt: mt || '10'
    };
    if (position === 'bottom-right') {
        positionProps = {
            mx: mx || { base: 4, md: '12' },
            mt: mt || '10'
        };
    }
    if (position === 'top-left') {
        positionProps = {
            mx: mx || { base: 4, md: '-12' },
            mt: mt || '10'
        };
    }
    if (position === 'top-right') {
        positionProps = {
            mx: mx || { base: 4, md: '12' },
            mt: mt || '10'
        };
    }
    return (React.createElement(Box, { zIndex: "1", position: "absolute", bg: mode('white', 'gray.700'), borderColor: mode('border.secondary', 'gray.600'), borderWidth: 1, boxShadow: mode('lg', 'dark-lg'), rounded: "lg", w: "180px", p: 2, ...positionProps, overflow: "revert" },
        React.createElement(HStack, { spacing: 2 },
            React.createElement(Icon, { as: icon, color: iconColor }),
            React.createElement(Text, { fontWeight: "medium", size: "md" }, message))));
};
export const GeofenceAlert = (props) => {
    const { position = 'top-left' } = props;
    let positionProps = {
        mx: { base: 4, md: '-12' },
        mt: '10'
    };
    if (position === 'top-right') {
        positionProps = {
            mx: { base: 4, md: '-12' },
            mt: '10'
        };
    }
    return (React.createElement(Box, { zIndex: "1", position: "absolute", bg: mode('white', 'gray.800'), boxShadow: "md", rounded: "lg", p: 2, ...positionProps },
        React.createElement(HStack, { spacing: 2 },
            React.createElement(Icon, { as: ArrowDownIcon, color: mode('purple.500', 'purple.400') }),
            React.createElement(Text, { fontWeight: "bold", size: "md" }, "Arrived at Origin 2:47 PM"))));
};
export const MapMessage = () => {
    return (React.createElement(Box, { zIndex: "1", position: "absolute", bg: mode('white', 'gray.800'), boxShadow: "md", rounded: "lg", p: 2, mx: { base: 4, md: '150' }, mt: "-50px" },
        React.createElement(HStack, { spacing: 2, alignItems: "center" },
            React.createElement(Avatar, { src: 'https://chaineapp.com/_images/avatars/peter.jpg', size: "sm" }),
            React.createElement(Box, { w: "2xs" },
                React.createElement(Highlight, { query: "@Jasvir", styles: {
                        px: 1,
                        py: '1px',
                        bg: mode('teal.100', 'teal.200'),
                        fontSize: 'md',
                        fontWeight: 'semibold',
                        borderRadius: 'md',
                        alignContent: 'center'
                    } }, "@Jasvir Please have Monica check-in at door 2.")))));
};
export const MapWithNotifications = (props) => {
    const { leftComponent, rightComponent, preventPopupsOnHover = false } = props;
    const { colorMode } = useColorMode();
    const mapStyle = mode('mapbox://styles/mapbox/streets-v11', 'mapbox://styles/mapbox/dark-v10');
    const origin = stops[0];
    const [style, setStyle] = useState(mapStyle);
    useEffect(() => {
        setStyle(mapStyle);
    }, [colorMode, mapStyle]);
    const handleSetLocationOnFirstRender = (map) => {
        map?.easeTo({
            center: {
                lat: origin.warehouse.address.coordinates.latitude,
                lng: origin.warehouse.address.coordinates.longitude
            },
            duration: 1000,
            zoom: 13
        });
    };
    return (React.createElement(StyledBox, { px: 3, borderColorProps: { light: 'blue.500', dark: 'blue.800' }, height: "full", width: 'full', sx: {
            '.mapboxgl-control-container': {
                display: 'none !important'
            }
        } },
        leftComponent,
        React.createElement(MapProvider, null,
            React.createElement(ReactMapGl, { id: "map", reuseMaps: true, onLoad: ({ target: map }) => {
                    handleSetLocationOnFirstRender(map);
                }, initialViewState: defaultViewState, mapStyle: style, mapboxAccessToken: mapToken },
                React.createElement(StopsMarkers, { stops: [origin], preventPopupsOnHover: preventPopupsOnHover }),
                origin.warehouse.address.geofence && (React.createElement(GeofenceBoundary, { geofence: origin.warehouse.address.geofence, id: '123', routeColor: mode(lightColors.purple[400], darkColors.purple[400]) })),
                React.createElement(CurrentLocationMarker, { color: mode(lightColors.blue[400], darkColors.blue[400]), ...currentLocationArrivedOrigin, preventPopupsOnHover: preventPopupsOnHover }))),
        rightComponent));
};
